import { useAuthUser } from 'react-auth-kit';
import { useMemo } from 'react';
import useAppQuery from './useAppQuery';
import { config } from 'variables/config';

const useGetGeoScopeForCurrentUser = () => {
  const auth = useAuthUser();
  const userId = auth()?.user?.id;

  const url = useMemo(
    () => (userId ? `${config.app.api_url}/users/${userId}/geo-scope` : null),
    [userId]
  );

  const { isLoading: loadingGeo, data: geoScope } = useAppQuery(url);

  return useMemo(() => ({ loadingGeo, geoScope }), [loadingGeo, geoScope]);
};

export default useGetGeoScopeForCurrentUser;
